import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import { setTBillEditedData } from '../../store/actions';

function RateTableInput(props) {
  const { updateDataAction, cellInfo, isEnablebyRole } = props;
  const rx_live = /^\d\.\d{6}$/;
  const dispatch = useDispatch();

  const editedData = useSelector(
    (state) => state.sharedState.TBillTableReducer.editedData
  );
  const setEditedData = (value) => dispatch(setTBillEditedData(value));
  const tBillErrorMsg = useSelector(
    (state) => state.sharedState.TBillTableReducer.errorField
  );

  const resultData = useSelector(
    (state) => state.sharedState.TBillTableReducer.allTBillList
  );
  // get edited data
  const onEditingStopped = React.useCallback(
    (e) => {
      const objList = _.isEmpty(editedData)
        ? []
        : _.filter(editedData, (l) => l.id === e.data?.id);
      if (e.data.isEdit && !_.isEmpty(objList)) {
        const obj = objList[0];
        obj.index = e.rowIndex;
        obj.isError = obj.tbillRate === '' || !rx_live.test(obj.tbillRate);
        obj.isEdit = false;
        const newData = !_.isEmpty(editedData)
          ? _.filter(editedData, (l) => l.id !== e.data?.id)
          : [];
        newData.push(obj);
        setEditedData(newData);
      }
    },
    [editedData]
  );

  const isErrorViewList = !_.isEmpty(editedData)
    ? _.filter(editedData, (l) => l.id === cellInfo.data.id && l.isError)
    : [];
  const isErrorView = _.isEmpty(isErrorViewList)
    ? false
    : isErrorViewList[0].isError;

  return (
    <div className="form-wrapper vertical-wrapper">
      <TextField
        className={
          // eslint-disable-next-line no-nested-ternary
          isErrorView
            ? cellInfo.data?.tbillRate === '' ||
              !rx_live?.test(cellInfo.data.tbillRate)
              ? 'td-active-cell tBill-validate frr-display-hidden-label'
              : 'frr-display-hidden-label'
            : 'frr-display-hidden-label'
        }
        fullWidth
        disabled={!isEnablebyRole}
        placeholder=""
        inputProps={{ maxLength: 8 }}
        InputLabelProps={{
          shrink: true,
          id: `tBillId_${cellInfo.rowIndex}`,
        }}
        label={`${cellInfo?.colId}${cellInfo.rowIndex}`}
        onFocus={(e) => {
          const agGridBody = e.currentTarget.closest('.ag-body-viewport');
          agGridBody
            .querySelectorAll('.ag-row-selected')
            .forEach((b) => b.classList.remove('ag-row-selected'));
          e.currentTarget.closest('.ag-row').classList.add('ag-row-selected');
        }}
        onChange={(e) => {
          const validNumber = new RegExp(/^\d*\.?\d*$/);
          if (validNumber.test(e.target.value)) {
            cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
          }
          if (
            !_.isEmpty(tBillErrorMsg.errorMessages) &&
            e.target.value.length === 8
          ) {
            updateDataAction('onBlur', cellInfo);
          }
        }}
        onKeyDown={(e) => {
          // if ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight') {
          //   props.addAction(e, cellInfo, editedData, resultData);
          // }
        }}
        onBlur={(e) => {
          if (!_.isEmpty(e.target.value)) {
            let value = parseFloat(e.target.value);
            if (value <= 0) {
              value = 0.0;
            }
            const formattedValue = value.toFixed(6);
            cellInfo.node.setDataValue(cellInfo.column.colId, formattedValue);
          }
          onEditingStopped(cellInfo);
          updateDataAction('onBlur', cellInfo);
        }}
        value={cellInfo.value}
        id={`tBillId_${cellInfo.rowIndex}`}
      />
      <span className="frr-tbill-errormsg">
        {isErrorView
          ? cellInfo?.value === ''
            ? 'Rate is Required'
            : !rx_live?.test(cellInfo.value)
            ? 'X.XXXXXX should be the format for T-Bill Rate'
            : ''
          : ''}
      </span>
    </div>
  );
}

export default RateTableInput;
